<div class="team-dashboard">
    <app-key-performance-indicators [kpiData]="filteredKpiData" [currentAssignedCases]="memberFilteredAssignedCases.length"></app-key-performance-indicators>
    <team-performance-component
        [rawPerformanceData]="rawPerformanceData"
        [accountFilter]="accountFilter"
    ></team-performance-component>
    <div class="filter-container">
        <div class="filter-container-title">
            <h3>Case Reporting</h3>
            <div class="middle-line"></div>
        </div>
        <banner-component></banner-component>
        <app-dashboard-sla-due-date-filters
            [slaDueDateCounts]="slaDueDateCounts"
            [totalItems]="accountScopedCases.length"
            [isDisabled]="!atLeastOneQueueHasSLA"
            [selectedIds]="slaFilters"
            (valueEmitted)="handleslaFiltersEmitted($event)"
        ></app-dashboard-sla-due-date-filters>
        <div class="filterPane" *ngIf="queueFilters.length > 0">
            <div class="filterPane-header" (click)="isFilterPaneCollapsed = !isFilterPaneCollapsed">
                <mat-icon class="filterPane-icon" [class.collapsed]="isFilterPaneCollapsed">arrow_drop_up</mat-icon>
                <span class="filterPane-label">Queues</span>
            </div>
            <div class="filterPane-content" *ngIf="!isFilterPaneCollapsed" @slideToggle>
                <app-queue-filter-carousel
                    [filters]="queueFilters"
                    [allCasesId]="allCasesQueueId"
                    [selectedCount]="getSelectedFiltersCount()"
                    [isSideNavHidden]="isSideNavHidden"
                    (valueEmitted)="onQueueFilterEmitted($event)"
                ></app-queue-filter-carousel>
            </div>
        </div>
    </div>
    <div class="mrs-table-inner-container" style="background-color: white; padding: 16px; gap: 8px;">
        <div class="d-flex align-items-center" style="gap: 8px;">
            <h2 style="margin: 0;">{{ team?.name }} Team</h2>
            <mat-chip *ngIf="(selectedQueueIds.length + slaFilters.length) > 0" disabled class="filter-count-badge">
                {{ selectedQueueIds.length + slaFilters.length }} Filter{{ (selectedQueueIds.length + slaFilters.length) === 1 ? '' : 's' }} Active
            </mat-chip>
        </div>
        <br />
        <mat-tab-group (selectedTabChange)="onTabChange($event.index)">
            <mat-tab label="Cases By Member">
                <team-workload-table
                    [teamId]="team?.id"
                    [teamData]="teamData"
                    [filteredCases]="filteredAssignedCases"
                    [filteredTasks]="filteredAssignedTasks"
                    [isFiltered]="isQueueOrSlaFilterActive"
                    [activeFilterCount]="selectedQueueIds.length + slaFilters.length"
                    [tasksEnabled]="teamTasksEnabled"
                    (selectedTeamMembersChange)="onTeamMembersSelectionChange($event)"
                ></team-workload-table>
            </mat-tab>
            <mat-tab label="Cases By Account">
                <account-workload-table
                    [allCases]="accountScopedCases"
                    [filteredCases]="filteredAssignedCases"
                    [allTasks]="accountScopedTasks"
                    [filteredTasks]="filteredAssignedTasks"
                    [isFiltered]="isQueueOrSlaFilterActive"
                    [activeFilterCount]="selectedQueueIds.length + slaFilters.length"
                    [tasksEnabled]="teamTasksEnabled"
                    (selectedAccountsChange)="onAccountsSelectionChange($event)"
                ></account-workload-table>
            </mat-tab>
        </mat-tab-group>
    </div>
    <assigned-cases-table
        [cases]="memberFilteredAssignedCases"
        [clientId]="team?.clientId"
        [teamId]="team?.id"
        [teamUsers]="teamUsers"
        [userCaseCounts]="userCaseCounts"
        [activeFilterCount]="selectedQueueIds.length + slaFilters.length"
        [tasksEnabled]="teamTasksEnabled"
        (casesAssigned)="loadTeamData()"
    ></assigned-cases-table>
</div>